import UserAndTermLookup from '../components/UserAndTermLookup/UserAndTermLookup'
import Maintenance from './Maintenance'

const Home = () => {
  const maintenance = false

  return <div>{maintenance ? <Maintenance /> : <UserAndTermLookup />}</div>
}
export default Home
